<template>
  <div class="p-2 sm:p-4 text-lexend min-h-screen bg-gray-50 dark:bg-gray-900/50">
    <div class="mb-4">
      <h1 class="text-xl sm:text-3xl font-black text-gray-900 dark:text-white flex items-center gap-2">
        <Icon icon="mdi:cash-register" class="text-emerald-600" /> Pagos de Recarga
        <span class="px-2 py-0.5 bg-emerald-100 dark:bg-emerald-900/40 text-emerald-600 text-xs font-black rounded-lg">{{ pagos.length }}</span>
      </h1>
    </div>

    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border dark:border-gray-700 overflow-hidden">
      <div class="overflow-x-auto">
        <table class="w-full text-left">
          <thead class="bg-gray-50 dark:bg-gray-900/50 border-b dark:border-gray-700">
            <tr>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">RECIBO</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">PEDIDO</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest text-right">MONTO USD</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest text-right">MONTO Bs</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest text-center">MÉTODO</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">FECHA</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest text-center">ESTADO</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest text-right">ACCIONES</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
            <tr v-if="!loading && pagos.length === 0">
              <td colspan="8" class="px-5 py-16 text-center opacity-40">
                <Icon icon="mdi:cash-off" class="text-6xl mb-3 mx-auto" /><p>No hay pagos registrados</p>
              </td>
            </tr>
            <tr v-for="p in pagos" :key="p.idPagoPedidoRecarga" class="hover:bg-emerald-50/30 dark:hover:bg-gray-700/30">
              <td class="px-5 py-4"><span class="font-black text-xs text-gray-900 dark:text-white">{{ p.numeroRecibo }}</span></td>
              <td class="px-5 py-4"><span class="text-xs font-bold text-gray-700 dark:text-gray-300">{{ p.numeroPedido }}</span></td>
              <td class="px-5 py-4 text-right font-black text-emerald-600">${{ Number(p.montoUsd).toFixed(2) }}</td>
              <td class="px-5 py-4 text-right font-black text-blue-600">Bs. {{ Number(p.montoBs).toFixed(2) }}</td>
              <td class="px-5 py-4 text-center">
                <span class="px-2 py-1 bg-gray-100 dark:bg-gray-700 rounded-lg text-[10px] font-black uppercase text-gray-700 dark:text-gray-300">{{ p.metodoPago }}</span>
              </td>
              <td class="px-5 py-4 text-xs text-gray-600 dark:text-gray-300">{{ formatFecha(p.fechaPago) }}</td>
              <td class="px-5 py-4 text-center">
                <span :class="['px-2 py-1 text-[10px] font-black uppercase rounded-lg', p.estado === 'completado' ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700']">{{ p.estado }}</span>
              </td>
              <td class="px-5 py-4 text-right">
                <button v-if="p.estado === 'completado'" @click="anular(p)" class="px-2 py-1 bg-rose-50 text-rose-600 rounded-lg text-[9px] font-black">Anular</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { obtenerPagosPedidos, anularPagoPedido } from '@/api/gas.js';

export default {
  name: 'PagosRecargaList',
  components: { Icon },
  data() { return { pagos: [], loading: false }; },
  async mounted() { await this.load(); },
  methods: {
    formatFecha(f) { if (!f) return '-'; try { return new Date(f).toLocaleString('es-VE'); } catch { return f; } },
    async load() {
      this.loading = true;
      try { const res = await obtenerPagosPedidos(); if (res.success) this.pagos = res.data; }
      finally { this.loading = false; }
    },
    async anular(p) {
      const m = prompt('Motivo de anulación:');
      if (!m) return;
      const res = await anularPagoPedido(p.idPagoPedidoRecarga, m);
      if (res.success) await this.load();
      else alert(res.error || 'Error');
    }
  }
};
</script>

<style scoped>
.text-lexend { font-family: 'Lexend', sans-serif; }
</style>